import React, { useState, useEffect, useRef } from "react";
import './MessageA13s.css';
import prev from '../../../images/icons/prev.svg';
import next from '../../../images/icons/next.svg';
import selectedIcon from '../../../images/icons/selectedIcon.svg';
import unselectedIcon from '../../../images/icons/unselectedIcon.svg';

const MessageA13s = ({ item ,handleClick }) => {
  const [selectedBox, setSelectedBox] = useState(null);
  const carouselRef = useRef(null);
  const [showPrevArrow, setShowPrevArrow] = useState(false);
  const [showNextArrow, setShowNextArrow] = useState(true);
  const [isShowBtn, setIsShowBtn] = useState(false);
  const [boxData, setBoxData] = useState(null);

  const formattedArray = item?.text_data?.data?.map(entry => {
    const result = {};
    const lines = entry.name.split('<br>');
    lines.forEach(line => {
      if (!line.trim()) return;
      const splitIndex = line.indexOf(':');
      if (splitIndex === -1) return;
      const key = line.slice(0, splitIndex).trim();
      const value = line.slice(splitIndex + 1).trim();
      result[key] = value;
    });
    return result;
  });

  const handleScroll = () => {
    const carousel = carouselRef.current;
    const maxScrollLeft = carousel.scrollWidth - carousel.clientWidth;
    setShowPrevArrow(carousel.scrollLeft > 0);
    setShowNextArrow(carousel.scrollLeft < maxScrollLeft);
  };

  const scrollCarousel = (direction) => {
    const carousel = carouselRef.current;
    const scrollAmount = 300;
    carousel.scrollBy({
      left: direction === 'next' ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    const carousel = carouselRef.current;
    if (carousel) {
      carousel.addEventListener('scroll', handleScroll);
      handleScroll(); // initial check
      return () => carousel.removeEventListener('scroll', handleScroll);
    }
  }, []);



  const onBoxSelection = (index) =>{
    setIsShowBtn(true)
    setSelectedBox(index)
    setBoxData(formattedArray[index]?.Type)
  }

  return (
    <>
    <div className="carousel-container">
      <img
        src={prev}
        alt="Previous"
        className={`arrow-box prev ${showPrevArrow ? '' : 'hide'}`}
        onClick={() => scrollCarousel('prev')}
      />

      <div className="card-wrapper" ref={carouselRef}>
        {formattedArray?.map((box, index) => (
          <div
            className={`info-card ${selectedBox === index ? 'selected' : ''} action-tab`}
            key={index}
            onClick={() => {onBoxSelection(index)}}
          >
            <img
              src={selectedBox === index ? selectedIcon : unselectedIcon}
              alt="selection"
              className="top-icon"
            />
            <table className="info-table">
              {Object.entries(box).map(([key, value]) => (
                <tr key={key}>
                  <td className="key-cell"><strong>{key}</strong></td>
                  <td className="value-cell">{value}</td>
                </tr>
              ))}
            </table>
          </div>
        ))}
      </div>

      <img
        src={next}
        alt="Next"
        className={`arrow-box next ${showNextArrow ? '' : 'hide'}`}
        onClick={() => scrollCarousel('next')}
      />
    </div>
      <div className="BoxSelection-button action-tab">
      <button
        style={{
          opacity: !isShowBtn ? "0.5" : 1,
          pointerEvents: !isShowBtn ? "none" : "auto",
        }}
        onClick={() =>  handleClick(item?.code, boxData, item?.tag)}
      >
        {item?.text_data?.buttonTextAction}
      </button>
    </div>
    </>
  );
};

export default MessageA13s;
